module.exports = __webpack_public_path__ + "img/unlimited-character.6ac1ccd3.svg";